export const BANKS_FETCH_REQUEST = 'BANKS_FETCH_REQUEST';
export const GET_END_TO_END = "BANKS.GET_END_TO_END";
export const CREATE_DIRECT_DEBIT = "BANKS.CREATE_DIRECT_DEBIT";
export const PREPARE_EMANDATE = "BANKS.PREPARE_EMANDATE";
export const CANCEL_PREPARE_EMANDATE = "BANKS.CANCEL_PREPARE_EMANDATE";
export const VERIFY_EMANDATE = "BANKS.VERIFY_EMANDATE";